module.exports = __webpack_public_path__ + "img/yt-gray.928995e5.svg";